<form [formGroup]="verifyEmailForm" (submit)="verifyEmail()" class="w-full" novalidate>
  <div class="frame-content flex flex-col gap-4">
    <div class="title text-center">Email verification</div>

    <mat-form-field>
      <mat-label>Please provide a valid email</mat-label>
      <input
        matInput
        type="email"
        placeholder="Email"
        formControlName="email"
        (input)="showErrorSummary = false"
        required
      />
      <mat-error *ngIf="email.invalid">{{ getErrorEmail() }}</mat-error>
    </mat-form-field>

    <div class="noti-summary error" *ngIf="showErrorSummary">{{ error }}</div>
    <div class="noti-summary success" *ngIf="showSuccessSummary">
      We’ll send an email with a verification URL to the above address. Please check and click on the URL to complete
      the process
    </div>

    <button
      mat-raised-button
      type="submit"
      color="primary"
      [loading]="indicator"
      [style.backgroundColor]="verifyEmailForm.valid && !indicator ? partner.loginButtonBackground : ''"
      [disabled]="verifyEmailForm.invalid || indicator"
    >
      Verify my email
    </button>
  </div>
</form>
